module.exports = __webpack_public_path__ + "img/banner1.a0309c8e.png";